<template>
  <div class="notification-settings">
    <div class="columns toolbar-box"><div class="column is-2"><h1 class="title is-3 between-center">Notification Settings</h1></div></div>
    
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Notification Type</th>
                <th>Description</th>
                <th class="center-switch">Send Email</th>
                <th class="center-switch">Send Notification</th>
              </tr>
            </thead>
            <tbody>
                <tr class="no-padding">
                  <td>All Notifications</td>
                  <td class="td-description">Toggle all notifications</td>
                  <td class="center-switch"><o-switch @update:modelValue="SetAllSendMail" :value="true"></o-switch></td>
                  <td class="center-switch"><o-switch @update:modelValue="SetAllSendNotifications" :value="true" ></o-switch></td>
                </tr>
                <tr v-for="n in notifications" :key="n.notification_type">
                  <td>{{ n.name }}</td>
                  <td class="td-description">{{ n.description }}</td>
                  <td class="center-switch"><o-tooltip label="This type does not send email" type="is-info" :active="!n.hasMailNotification"><o-switch :disabled="!n.hasMailNotification" v-model="n.send_mail" @update:modelValue="toggleNotification(n)"></o-switch></o-tooltip></td>
                  <td class="center-switch"><o-tooltip label="This type does not send notification" type="is-info" :active="!n.hasNotification"><o-switch :disabled="!n.hasNotification" v-model="n.send_notification" @update:modelValue="toggleNotification(n)"></o-switch></o-tooltip></td></tr>
            </tbody>
          </table>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"

export default {
  mixins: [],

  data() {
    return {
      selectAll: false,
      filters: {
        queryType: 0,
      },
      notifications: []
    }
  },
  watch: {
    selectAll(value) {
      this.paginatedData.forEach((n) => (n.selected = value))
    },
    currentPage() {
      this.fetchPaginatedData(false)
    },
    "filters.queryType"() {
      this.fetchPaginatedData(true)
    },
  },
  mounted() {
    this.notifications = this.notification_setting_types.map(p =>  { return { notification_type: p.notification_type, name: p.name, description: p.description, send_mail: p.hasMailNotification, send_notification: p.hasNotification, hasMailNotification: p.hasMailNotification, hasNotification: p.hasNotification } })
    this.fetchNotificationSettings().then(p => {
      var result = p.data.data;
      if(result) {
        result.forEach(item => {
          var notificationItem = this.notifications.filter(n => n.notification_type == item.notification_type)[0]
          notificationItem.id = item.id
          notificationItem.send_mail = item.send_mail
          notificationItem.send_notification = item.send_notification
        }) 
      }
    });
  },
  computed: {
    ...mapGetters(['notification_setting_types']),
    selectedNotifications() {
      return _.filter(this.paginatedData, (n) => n.selected)
    }
  },

  methods: {
    ...mapActions(['fetchNotificationSettings', 'toggleNotificationSettings']),
    SetAllSendMail(value) {
      this.notifications.forEach( n => {
        n.send_mail = n.hasMailNotification ? value : false
        this.toggleNotification(n)
        })
      this.$forceUpdate()
    },
    SetAllSendNotifications(value) {
      this.notifications.forEach(n => {
        n.send_notification = n.hasNotification ? value : false
        this.toggleNotification(n)
      })
      this.$forceUpdate()
    },
    toggleNotification(type) {
      this.toggleNotificationSettings(type).then(p =>  type.id = p.data.data.id )
    }
  },
}
</script>

<style>
.notification-settings .table tr:nth-child(even) {background-color: #f2f2f2;}
.notification-settings .table tr:nth-child(odd) {background-color: #fff;}
.notification-settings .table thead { border-bottom: 1px solid #f0f0f0}
.notification-settings .table { border: none!important; }
.notification-settings .table .center-switch { width: 179px; text-align: center!important;}
.notification-settings tr.no-padding td { padding: 17px 9px; font-weight: bold; background-color: #e3e7ed; min-width: 165px; }
.notification-settings  td.td-description { width: 100%; }

@media (min-width: 1380px) and (max-width: 1599px) {
  .notification-settings .table td
  {
    padding: 10px 9px;
  }
}

.notification-settings .switch[disabled] { opacity: 0.2; }
</style>
